<ng-container *ngTemplateOutlet="tplMenu; context: { items: navItems(), level: 1 }"></ng-container>

<ng-template #tplMenu let-items="items" let-level="level">
  @for (item of items; track item) {
    <div class="level-{{ level }}">
      <ui-menu-item
        [item]="item"
        [isActive]="isActive(item)"
        [level]="level"
        (selectBeforeNavigate)="setSelectedItem(item)"
      ></ui-menu-item>

      @if (item.children?.length) {
        <ui-expander-content [expanded]="isExpanded(item)">
          <ng-container *ngTemplateOutlet="tplMenu; context: { items: item.children, level: level + 1}"></ng-container>
        </ui-expander-content>
      }
    </div>
  }
</ng-template>
